import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import InputComponent from 'app_components/commons/Input/InputComponent'
import TermService from 'app_services/admin/term/termService'
import { Terms, ITerm } from 'app_types/admin/term/term.types'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import React, { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import './TermForm.scss'

interface ITermFormProps {
  type: Terms
  onTermCreated?: () => void
  onTermUpdated?: () => void
  onCancel?: () => void
  term?: ITerm
  position?: number
}

const TermForm: FC<ITermFormProps> = ({ onTermCreated, onCancel, onTermUpdated, type, term, position }) => {
  const formHook = useForm({ defaultValues: {
    name: term?.name ? term?.name : '',
  } })
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const termService = new TermService()
  const screenNotification = new ScreenNotificationsUtil()

  const handleSubmit = async (data: ITerm) => {
    setIsLoading(true)
    if (term?._id) {
      const response = await termService.update({ ...term, id: term._id, ...data })
      if (response?.code === 200) {
        onTermUpdated && onTermUpdated()
        screenNotification.showSuccessTimer()
      }
    } else {
      const response = await termService.create({ ...data, type, position })
      if (response?.code === 200) {
        onTermCreated && onTermCreated()
        screenNotification.showSuccessTimer()
      }
    }
    setIsLoading(false)
  }

  const handleClickCancel = () => {
    onCancel && onCancel()
  }

  return (
    <div className="term-form--layout">
      <form onSubmit={formHook.handleSubmit(handleSubmit)}>
        <InputComponent
          name='name'
          label='Nombre'
          formHook={formHook.register({ required: true })}
          invalid={!!formHook?.errors?.name}
          invalidText="El nombre es requerido"
        />
        <div className='term-form--actions'>
          <ButtonComponent disabled={isLoading} variant='secondary' onClick={handleClickCancel} type="button">
            Cancelar
          </ButtonComponent>
          <ButtonComponent variant='primary' loading={isLoading} type="submit">
            {term?._id ? 'Guardar' : 'Crear'}
          </ButtonComponent>
        </div>
      </form>
    </div>
  )
}

export default TermForm
